import { closeMobileNav, setIsMobileNavOpen } from '@app/redux/ui/actions';
import { useDispatch, useSelector } from 'react-redux';
import { getIsMobileNavOpen } from '@app/redux/ui/selectors';

type useMobileNavOpenReturn = {
  isOpen: boolean;
  handleToggle: () => void;
  handleClose: () => void;
};

/**
 *
 */
const useMobileNavOpen = (): useMobileNavOpenReturn => {
  const dispatch = useDispatch();
  const isOpen = useSelector(getIsMobileNavOpen);

  return {
    isOpen,
    handleToggle: () => {
      dispatch(setIsMobileNavOpen());
    },
    handleClose: () => {
      dispatch(closeMobileNav());
    },
  };
};

export default useMobileNavOpen;
